import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface FinishTabProps {
  onFinish: () => void;
  submitting: boolean;
}

/** Finish tab — review copy + Finish button. */
export function FinishTab({ onFinish, submitting }: FinishTabProps) {
  return (
    <div className="grid gap-6">
      <div className="grid gap-3">
        <h2 className="font-heading text-foreground text-2xl font-bold">Almost done</h2>
        <p className="text-muted-foreground text-sm leading-relaxed">
          Please review the information you entered on the previous tabs. When
          everything looks correct, click <strong>Finish</strong> to submit your
          profile. We&apos;ll check that all required fields are complete — if
          anything is missing, we&apos;ll take you back to it.
        </p>
      </div>

      <Card className="bg-muted/40">
        <CardContent className="flex items-start gap-3 pt-6">
          <CheckCircle2 className="text-primary mt-0.5 size-5 shrink-0" />
          <p className="text-muted-foreground text-sm">
            After you submit, your tax professional is notified and will review
            your details. You won&apos;t be able to edit this form again from this
            link.
          </p>
        </CardContent>
      </Card>

      <div>
        <Button onClick={onFinish} disabled={submitting} size="lg">
          {submitting ? "Submitting…" : "Finish"}
        </Button>
      </div>
    </div>
  );
}
